import { utils } from './components/utils';
import { videoBannerInit } from './components/hero/video_banner';
import { videos } from './components/videos';
import initResourcesDetails from './components/resources_details';
import initResourcesTracking from './components/resources-tracking';
import initMarketoEmbedForms from './components/form-embed-marketo';
import initLazyLoad from './components/lazyLoad';
import initIframeResponsive from './components/iframe-responsive';
import oneTrustToggleInfoDisplay from './components/onetrust/toggleInfoDisplay';
import { initDrift } from './api/drift';
import dataLayerPageLoad from './components_split/_imports/dataLayers/page-load.common';
import { dataLayerCtaGlobal } from './components_split/_imports/dataLayers/cta-global.common';
import { initCtaTarget } from './components_split/cta/cta';
import amplitudeCtaGlobal from './components_split/_imports/amplitude/links.common';
import { setHeaderHeight, setMainNavHeight } from './components_split/_imports/utils/utils.common';


const initComponents = () => {
    utils();
    setHeaderHeight();
    setMainNavHeight();
    initDrift();
    videoBannerInit();
    videos();
    initResourcesDetails();
    initResourcesTracking();
    initMarketoEmbedForms();
    initLazyLoad();
    initIframeResponsive();
    oneTrustToggleInfoDisplay();
    dataLayerCtaGlobal();
    dataLayerPageLoad();
    initCtaTarget();
    amplitudeCtaGlobal();
};

export default initComponents;
